enum SubmitResult {
    Successful,
    PartiallySuccessful,
    Failed,
    DidNotRun,
    NotApplicable
}

export default SubmitResult;
